"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepEqualityComparer = deepEqualityComparer;
exports.pointEqualityComparer = pointEqualityComparer;
exports.sizeEqualityComparer = sizeEqualityComparer;
exports.rectEqualityComparer = rectEqualityComparer;
exports.rangeEqualityComparer = rangeEqualityComparer;
exports.thicknessEqualityComparer = thicknessEqualityComparer;
var isEqual = require("lodash/fp/isEqual");
function deepEqualityComparer(a, b) {
    return isEqual(a, b);
}
function pointEqualityComparer(a, b) {
    return a.x === b.x && a.y === b.y;
}
function sizeEqualityComparer(a, b) {
    return a.width === b.width && a.height === b.height;
}
function rectEqualityComparer(a, b) {
    return sizeEqualityComparer(a, b) && pointEqualityComparer(a, b);
}
function rangeEqualityComparer(a, b) {
    return a.start === b.start && a.end === b.end;
}
function thicknessEqualityComparer(a, b) {
    return a.left === b.left && a.top === b.top && a.right === b.right && a.bottom === b.bottom;
}
//# sourceMappingURL=EqualityComparers.js.map